export default {"src":"/_next/static/media/google-logo.2c01db3e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};